module.exports = __webpack_public_path__ + "static/media/YFI-USDT.1989d393.svg";